import {
  FiltersSlice,
  FollowSignalData,
  GetSignalsRequest,
  QueryStatus,
  Signal,
} from "@shared/types";

export const SignalsStatus = {
  OPEN: "Open",
  CLOSED: "Closed",
} as const;

type SignalsStatusType = typeof SignalsStatus;

export type SignalsStatusKeyType = keyof SignalsStatusType;

export type SignalsStatusValueType = SignalsStatusType[SignalsStatusKeyType];

export enum FollowSignalType {
  FOLLOW = 1,
  UPDATE = 2,
  CANCEL = 3,
}

export enum FollowSignalStatus {
  FOLLOWING = "Following",
  NOT_FOLLOWING = "Not Following",
}

export interface SignalFollowModalProps {
  closeModal: () => void;
  signal?: FollowSignalData;
  followType?: FollowSignalType;
  visible?: boolean;
}

export interface UseFollowSignalActionButton {
  signal: FollowSignalData;
  followType: FollowSignalType;
  onOpenModal?: () => void;
}

export interface SignalTableActionButtonProps {
  signal: FollowSignalData;
  followType: FollowSignalType;
  isDrawer?: boolean;
}

export interface SignalsPageData {
  signalsData?: Signal[];
  getSignalsDataQuery: QueryStatus;
  filtersSlice: FiltersSlice;
  args?: GetSignalsRequest;
}

export enum SignalColumn {
  TIME = "time",
  SYMBOL = "symbol",
  POTENTIAL_PROFIT = "potentialProfits",
  PROGRESS = "progress",
}
